import fetchDataService from "./fetchDataService";

const api_request = async (requestPromise: Promise<any>, errorMessage: string) => {
  try {
    const response = await requestPromise;
    if (response?.error || (response?.status && response.status !== 200)) {
      throw new Error(response.message || response.error || errorMessage);
    }
    return response;
  } catch (err: any) {
    return { error: true, message: err.message || errorMessage };
  }
};

// Instances
const createInstance = async (tokenData: any, requestData: any) => {
  return await api_request(
    fetchDataService.post("/traceability/create-instance", tokenData.key, {
      ...requestData,
      csrfToken: tokenData.token.uid,
    }),
    "Error al crear elemento trazable"
  );
};

const createInstancesBulk = async (tokenData: any, requestData: any) => {
  return await api_request(
    fetchDataService.post("/traceability/create-instances-bulk", tokenData.key, {
      ...requestData,
      csrfToken: tokenData.token.uid,
    }),
    "Error al crear elementos trazables en lote"
  );
};

const updateInstance = async (tokenData: any, requestData: any) => {
  return await api_request(
    fetchDataService.post("/traceability/update-instance", tokenData.key, {
      ...requestData,
      csrfToken: tokenData.token.uid,
    }),
    "Error al actualizar elemento trazable"
  );
};

const getInstances = async (tokenData: any, requestData: any) => {
  return await api_request(
    fetchDataService.post("/traceability/get-instances", tokenData.key, {
      ...requestData,
      csrfToken: tokenData.token.uid,
    }),
    "Error al consultar elementos trazables"
  );
};

const getInstance = async (tokenData: any, requestData: any) => {
  return await api_request(
    fetchDataService.post("/traceability/get-instance", tokenData.key, {
      ...requestData,
      csrfToken: tokenData.token.uid,
    }),
    "Error al consultar elemento trazable"
  );
};

const deleteInstance = async (tokenData: any, requestData: any) => {
  return await api_request(
    fetchDataService.post("/traceability/delete-instance", tokenData.key, {
      ...requestData,
      csrfToken: tokenData.token.uid,
    }),
    "Error al dar de baja elemento trazable"
  );
};

// Logs
const createLog = async (tokenData: any, requestData: any) => {
  return await api_request(
    fetchDataService.post("/traceability/create-log", tokenData.key, {
      ...requestData,
      csrfToken: tokenData.token.uid,
    }),
    "Error al registrar evento"
  );
};

const createLogsBulk = async (tokenData: any, requestData: any) => {
  return await api_request(
    fetchDataService.post("/traceability/create-logs-bulk", tokenData.key, {
      ...requestData,
      csrfToken: tokenData.token.uid,
    }),
    "Error al registrar eventos en lote"
  );
};

const getLogs = async (tokenData: any, requestData: any) => {
  return await api_request(
    fetchDataService.post("/traceability/get-logs", tokenData.key, {
      ...requestData,
      csrfToken: tokenData.token.uid,
    }),
    "Error al consultar eventos"
  );
};

const addLogAttachment = async (tokenData: any, requestData: any) => {
  return await api_request(
    fetchDataService.post("/traceability/add-log-attachment", tokenData.key, {
      ...requestData,
      csrfToken: tokenData.token.uid,
    }),
    "Error al guardar adjunto"
  );
};

const deleteLogAttachment = async (tokenData: any, requestData: any) => {
  return await api_request(
    fetchDataService.post("/traceability/delete-log-attachment", tokenData.key, {
      ...requestData,
      csrfToken: tokenData.token.uid,
    }),
    "Error al eliminar adjunto"
  );
};

// Groups
const createGroup = async (tokenData: any, requestData: any) => {
  return await api_request(
    fetchDataService.post("/traceability/create-group", tokenData.key, {
      ...requestData,
      csrfToken: tokenData.token.uid,
    }),
    "Error al crear grupo trazable"
  );
};

const updateGroup = async (tokenData: any, requestData: any) => {
  return await api_request(
    fetchDataService.post("/traceability/update-group", tokenData.key, {
      ...requestData,
      csrfToken: tokenData.token.uid,
    }),
    "Error al actualizar grupo trazable"
  );
};

const getGroups = async (tokenData: any, requestData: any) => {
  return await api_request(
    fetchDataService.post("/traceability/get-groups", tokenData.key, {
      ...requestData,
      csrfToken: tokenData.token.uid,
    }),
    "Error al consultar grupos trazables"
  );
};

const getGroup = async (tokenData: any, requestData: any) => {
  return await api_request(
    fetchDataService.post("/traceability/get-group", tokenData.key, {
      ...requestData,
      csrfToken: tokenData.token.uid,
    }),
    "Error al consultar grupo trazable"
  );
};

const addGroupMembers = async (tokenData: any, requestData: any) => {
  return await api_request(
    fetchDataService.post("/traceability/add-group-members", tokenData.key, {
      ...requestData,
      csrfToken: tokenData.token.uid,
    }),
    "Error al agregar miembros al grupo"
  );
};

const removeGroupMembers = async (tokenData: any, requestData: any) => {
  return await api_request(
    fetchDataService.post("/traceability/remove-group-members", tokenData.key, {
      ...requestData,
      csrfToken: tokenData.token.uid,
    }),
    "Error al remover miembros del grupo"
  );
};

const linkCycleGroup = async (tokenData: any, requestData: any) => {
  return await api_request(
    fetchDataService.post("/traceability/link-cycle-group", tokenData.key, {
      ...requestData,
      csrfToken: tokenData.token.uid,
    }),
    "Error al vincular ciclo a grupo trazable"
  );
};

const getCycleGroup = async (tokenData: any, requestData: any) => {
  return await api_request(
    fetchDataService.post("/traceability/get-cycle-group", tokenData.key, {
      ...requestData,
      csrfToken: tokenData.token.uid,
    }),
    "Error al consultar grupo vinculado a ciclo"
  );
};

export default {
  createInstance,
  createInstancesBulk,
  updateInstance,
  getInstances,
  getInstance,
  deleteInstance,
  createLog,
  createLogsBulk,
  getLogs,
  addLogAttachment,
  deleteLogAttachment,
  createGroup,
  updateGroup,
  getGroups,
  getGroup,
  addGroupMembers,
  removeGroupMembers,
  linkCycleGroup,
  getCycleGroup,
};
